module.exports = __webpack_public_path__ + "img/mzc.4f5ab18a.svg";